import CreateIcon from '@mui/icons-material/Create';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { CreateButton } from 'features/documentCategories/components/DocumentCategories/styled';
import { useAuth } from 'hooks';
import { Links } from 'settings';
import { theme } from 'styles';

import { EmptyStateKpi } from '../EmptyStateKpi';
import { ContentW, VisionTitle, VisionDescription, HeaderW } from './styled';

interface VisionProps {
  vision: string | null;
}

export function Vision({ vision }: VisionProps): ReactElement {
  const { t } = useTranslation();
  const { isManager } = useAuth();
  const navigate = useNavigate();

  return (
    <ContentW>
      <HeaderW>
        <VisionTitle>{t('kpi.fullPage.ourVision')}</VisionTitle>
        {isManager && vision && (
          <CreateButton
            startIcon={<CreateIcon style={{ fill: theme.palette.common.white }} />}
            onClick={() => navigate(Links.we.kpi.editVision)}
            style={{
              height: '56px',
              padding: '16px 32px',
              backgroundColor: theme.palette.info.main,
              color: theme.palette.common.white,
              fontSize: '14px',
              fontWeight: 400,
              borderRadius: '8px',
              textTransform: 'none',
            }}
          >
            {t('kpi.visionForm.editTitle')}
          </CreateButton>
        )}
      </HeaderW>
      {vision ? (
        <VisionDescription dangerouslySetInnerHTML={{ __html: vision }} />
      ) : (
        <EmptyStateKpi type="vision" />
      )}
    </ContentW>
  );
}
